import React from 'react';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { CheckCircle2, Circle, Clock } from "lucide-react";
import { Badge } from "components/ui/badge";
import { format } from "date-fns";

export default function TaskSummary({ tasks }) {
  const { t } = useTranslation();
  const today = format(new Date(), 'yyyy-MM-dd');
  const todayTasks = tasks.filter(task => task.due_date === today);
  const completedToday = todayTasks.filter(task => task.completed).length;
  const pendingTasks = todayTasks.filter(task => !task.completed).slice(0, 5);

  const categoryColors = {
    'Küche': 'bg-blue-100 text-blue-700 border-blue-200',
    'Pizza': 'bg-orange-100 text-orange-700 border-orange-200',
    'FOH': 'bg-purple-100 text-purple-700 border-purple-200',
    'Allgemein': 'bg-slate-100 text-slate-700 border-slate-200',
  };

  const priorityColors = {
    'Dringend': 'text-red-600',
    'Hoch': 'text-orange-600',
    'Normal': 'text-slate-600',
    'Niedrig': 'text-slate-400',
  };

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg font-bold text-slate-900 flex items-center gap-2">
            <Clock className="w-5 h-5 text-blue-500" />
            {t("dashboard.todayTasks")}
          </CardTitle>
          <div className="text-sm font-semibold text-slate-600">
            {completedToday}/{todayTasks.length} {t("dashboard.completed")}
          </div>
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {pendingTasks.length === 0 ? (
          <div className="text-center py-8">
            <CheckCircle2 className="w-12 h-12 text-green-400 mx-auto mb-2" />
            <p className="text-slate-500 text-sm">{t("dashboard.allTasksCompleted")}</p>
          </div>
        ) : (
          <div className="space-y-2">
            {pendingTasks.map((task) => (
              <div key={task.id} className="flex items-start gap-3 p-3 bg-white border border-slate-200 rounded-lg hover:shadow-sm transition-all">
                <Circle className={`w-5 h-5 mt-0.5 ${priorityColors[task.priority]}`} />
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-slate-900 text-sm">{task.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <Badge className={`${categoryColors[task.category]} border text-xs`}>
                      {task.category}
                    </Badge>
                    {task.assigned_to && (
                      <span className="text-xs text-slate-500">{task.assigned_to}</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
